import { AppUserDiagnosticsStateChip, AppUserDiagnosticsTagChip } from 'components/ui';
import AppDialogHeader from 'components/ui/AppDiaglogHeader';
import { observer } from 'mobx-react-lite';
import { IUserDiagnostic, UserDiagnosticsState, UserDiagnosticsTag } from 'types/models/UserDiagnosticsModel';

interface IUserDiagnosticsAppDialogHeaderProps {
    title?: string;
    stickyHeader?: boolean;
    userDiagnostic: IUserDiagnostic | null
}

export const UserDiagnosticsAppDialogHeader = observer(({ title, stickyHeader, userDiagnostic }: IUserDiagnosticsAppDialogHeaderProps) => (
    <AppDialogHeader title={title} stickyHeader={stickyHeader}>
        <div className="d-flex justify-content-between align-items-center px-3 py-2">
            <div className='d-flex' style={{ minWidth: '120px' }}>
                <AppUserDiagnosticsStateChip userDiagnosticsState={userDiagnostic?.state as UserDiagnosticsState} />
            </div>

            <h3 className="font-22 font-500 text-uppercase mb-0 text-center flex-grow-1">
                {title}
            </h3>
            
            <div className="d-flex gap-10px">
                {userDiagnostic?.userDiagnosticsTags?.map((x, index) =>
                    <AppUserDiagnosticsTagChip key={`tag-${index}`} userDiagnosticsTag={x as UserDiagnosticsTag} />)
                }
            </div>
        </div>
    </AppDialogHeader>
));

export default UserDiagnosticsAppDialogHeader;